class CustomSearch {
    constructor() {
        this.init();
    }

    async init() {
    }

    isSkuId(searchValue) {
        return searchValue.startsWith('BMW');
    }

    async action(searchValue) {
        console.log("skuSearchAction", searchValue);

        if (this.isSkuId(searchValue)) {
            const skuQuery = `variants.sku:${searchValue}`;
            console.log("Redirecting to:", `/search?q=${encodeURIComponent(skuQuery)}`);
            window.location.href = `/search?q=${encodeURIComponent(skuQuery)}`;
        } else {
            const nameQuery = `${searchValue}`;
            window.location.href = `/search?q=${encodeURIComponent(nameQuery)}`;
        }
        
        return false;
    }
}

var customSearch = new CustomSearch();
